import { BLOG_API_BASE_URL } from 'constants/index';
import { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { IArticleItem } from '../Helper/interface';

export default function useFetchHomeLuxuryData() {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [data, setData] = useState<IArticleItem[]>([]);

  const fetchLuxuryData = async () => {
    try {
      setIsFetching(true);
      const response = await fetch(
        `${BLOG_API_BASE_URL}/articles?category=luxury&page=1&per_page=8&sort_by=createdAt_desc`,
      );
      const data = await response.json();
      if (data.error) {
        setIsFetching(false);
        setIsError(true);
        return;
      }
      setData(data.data.data);
      setIsFetching(false);
      return data;
    } catch (error) {
      setIsFetching(false);
      setIsError(true);
      setError(error);
      console.log('error fetchLuxuryData()', error);
      throw error;
    }
  };

  return { data, fetchLuxuryData, isFetching, isError, error };
}
